import RectanglesIcon from "./RectanglesIcon";

export default RectanglesIcon;
